import './styles/playerinfobaja.css'
import { useLocation, useNavigate } from 'react-router-dom'
import { useEffect, useState } from 'react'

//Components
import Loader from '../components/loader'
import Snack from '../components/snack'
import Confirm from '../components/confirm'
import Menu from '../components/menu'

//Extras
import { fontType, main } from '../assets/extras'
import { db } from '../assets/connections'
import { arrayUnion, collection, deleteDoc, doc, getDoc, getDocs, increment, query, setDoc, updateDoc, where } from 'firebase/firestore'
import { getAge, getCurrentDate, validateEmail } from '../assets/validator'
import { categorias, horas, niveles } from '../assets/datas'
import { MdDeleteOutline } from "react-icons/md"

const PlayerInfoBaja = () => {

    const navigate = useNavigate()
    
    const location = useLocation()
    const ref = location.state ? location.state.ref : null
    const id = location.state ? location.state.id : null
    const academia = location.state ? location.state.academia : null

    const [variables, setVariables] = useState({
        loading: true,
        data: {},
        suscripciones: [],
        classes: [],
        clase: [],
        confirm: false
    })

    //Varibles para el uso del confirm
    const [confirm, setConfirm] = useState({
        show: false,
        title: "",
        text: ""
    })

    //Control del mensaje snack
    const showMessage = (message, status) => {
        let contSnack = document.getElementById("contSnack")

        let snack = document.createElement("div")
        snack.classList.add("snack")

        snack.innerHTML = status == "success" ?
            "<i class='fa-regular fa-circle-check fa-beat' style='color: #56d600;'></i>" +
            "<p style='font-family:" + fontType.text + ";'>" + message + "</p>" +
            "<div className='snackBar' style='background-color: #56d600;'></div>"
            : status == "warning" ?
                "<i class='fa-solid fa-triangle-exclamation fa-beat' style='color: #f9b92f;'></i>" +
                "<p style='font-family:" + fontType.text + ";'>" + message + "</p>" +
                "<div className='snackBar' style='background-color: #f9b92f;'></div>"
                : status == "error" ?
                    "<i class='fa-solid fa-circle-xmark fa-beat' style='color: #c20000;'></i>" +
                    "<p style='font-family:" + fontType.text + ";'>" + message + "</p>" +
                    "<div className='snackBar' style='background-color: #c20000;'></div>"
                    : ""

        contSnack.appendChild(snack)
        setTimeout(() => {
            snack.remove()
        }, 5000)
    }

    //Variable que almacena los datos ordenados por dias
    var sortedDaysData = [
        [], //Lunes
        [], //Martes
        [], //Miercoles
        [], //Jueves
        [], //Viernes
        [], //Sabado
        [], //Domingo
    ]

    //Funcion que busca a que dia pertenece la clase
    const sortByDay = (clase) => {
        for(let i = 0; i < 7; i++){
            if(i === 0){ //Lunes
                let cont = 0
                for(let j = 0; j < clase.dias_clase.length; j++){
                    if(clase.dias_clase[j].dia === "Lunes"){
                        sortedDaysData[i].push(clase)
                        cont ++
                        break
                    }
                }

                if(cont > 0){
                    break
                }
            } else if(i === 1){ //Martes
                let cont = 0
                for(let j = 0; j < clase.dias_clase.length; j++){
                    if(clase.dias_clase[j].dia === "Martes"){
                        sortedDaysData[i].push(clase)
                        cont ++;
                        break
                    }
                }

                if(cont > 0){
                    break
                }
            } else if(i === 2){ //Miercoles
                let cont = 0
                for(let j = 0; j < clase.dias_clase.length; j++){
                    if(clase.dias_clase[j].dia === "Miercoles"){
                        sortedDaysData[i].push(clase)
                        cont ++
                        break
                    }
                }

                if(cont > 0){
                    break
                }
            } else if(i === 3){ //Jueves
                let cont = 0
                for(let j = 0; j < clase.dias_clase.length; j++){
                    if(clase.dias_clase[j].dia === "Jueves"){
                        sortedDaysData[i].push(clase)
                        cont ++
                        break
                    }
                }

                if(cont > 0){
                    break
                }
            } else if(i === 4){ //Viernes
                let cont = 0
                for(let j = 0; j < clase.dias_clase.length; j++){
                    if(clase.dias_clase[j].dia === "Viernes"){
                        sortedDaysData[i].push(clase)
                        cont ++
                        break
                    }
                }

                if(cont > 0){
                    break
                }
            } else if(i === 5){ //Sabado
                let cont = 0
                for(let j = 0; j < clase.dias_clase.length; j++){
                    if(clase.dias_clase[j].dia === "Sabado"){
                        sortedDaysData[i].push(clase)
                        cont ++
                        break
                    }
                }

                if(cont > 0){
                    break
                }
            } else if(i === 6){ //Domingo
                let cont = 0
                for(let j = 0; j < clase.dias_clase.length; j++){
                    if(clase.dias_clase[j].dia === "Domingo"){
                        sortedDaysData[i].push(clase)
                        cont ++
                        break
                    }
                }

                if(cont > 0){
                    break
                }
            }
        }
    }

    //Funcion que formatea el subitulo
    const formatSubtitle = (dias_clase) => {
        var dias = ""
        dias_clase.map(v => {
            var dia = ""
            var hora = v.de + "-" + v.a
            for (let i = 0; i < 3; i++) {
                dia += v.dia[i]
            }

            if (dias == "") {
                dias = dia + " " + hora
            } else {
                dias += " / " + dia + " " + hora
            }

        })

        return dias
    }

    //Funciones que borran al jugador
    const deletePlayer = () => {
        setConfirm(prev => ({
            ...prev,
            show: false
        }))
        setVariables(prev => ({
            ...prev,
            loading: true
        }))
        deletingPlayer()
    }
    const deletingPlayer = async () => {
        await deleteDoc(doc(doc(db, ref), "JugadorBaja", variables.data.correo_jugador)).then(r => {
            setVariables(prev => ({
                ...prev,
                loading: false
            }))
            setTimeout(() => {
                showMessage("Jugador eliminado", "success", 2000)
                setTimeout(() => {
                    window.history.back()
                }, 1000)
            }, 100)
        }).catch(e => {
            console.log(e.code + " " + e.message)
            setVariables(prev => ({
                ...prev,
                loading: false
            }))
            setTimeout(() => {
                showMessage("Error de conexion", "error")
            }, 100)
        })
    }

    //Funcion que da de baja al jugador
    const altaPlayer = () => {
        setVariables(prev => ({
            ...prev,
            loading: true
        }))

        var next = false
        var dates = false
        var newFinanceInscripcion = {
            cantidad: 0,
            concepto: "Inscripcion " + variables.data.nombre_jugador.split(" ").filter((v, i) => i <= 1).join(" "),
            categoria: "Inscripcion",
            fecha: "----/--/--"
        }
        var newFinanceMensualidad = {
            cantidad: 0,
            concepto: "Mensualidad " + variables.data.nombre_jugador.split(" ").filter((v, i) => i <= 1).join(" "),
            categoria: "Mensualidad",
            fecha: "----/--/--"
        }
        for (let i = 0; i < variables.suscripciones.length; i++) {
            if (variables.suscripciones[i].suscripcion === "Inscripcion") {
                if (variables.suscripciones[i].pagado > 0) {
                    next = true
                    newFinanceInscripcion.cantidad = parseInt(variables.suscripciones[i].pagado)
                }
                if(variables.suscripciones[i].fecha_pago === "----/--/--"){
                    dates = true
                    console.log(variables.suscripciones[i])
                } else {
                    newFinanceInscripcion.fecha = variables.suscripciones[i].fecha_pago
                }
            } else {
                newFinanceMensualidad.cantidad = parseInt(variables.suscripciones[i].pagado)
                newFinanceMensualidad.fecha = variables.suscripciones[i].fecha_pago
            }
        }
        if(next === false){
            setVariables(prev => ({
                ...prev,
                loading: false
            }))
            showMessage("Debes ingresar al menos el pago de la inscripcion", "warning")
        } else {
            if (dates === true ) {
                setVariables(prev => ({
                    ...prev,
                    loading: false
                }))
                showMessage("Debes ingresar la fecha de pago de la inscripcion", "warning")
            } else {
                alta(newFinanceInscripcion, newFinanceMensualidad)
            }
        }
    }
    const alta = async (financesInscripcion, financesMensualidad) => {
        var datos = {
            ...variables.data,
            clases_jugador: variables.clase,
            suscripciones_jugador: variables.suscripciones,
            asistencias_jugador: [],
            ranking_jugador: 0,
            ultima_asistencia: "----/--/--",
            fecha_alta: getCurrentDate()
        }

        await setDoc(doc(doc(db, ref), "Jugador", id), datos).then(async r => {
            await updateClassCont(variables.clase)
            await successAlta()
            await updateFinances(financesInscripcion, financesMensualidad)
        }).catch(e => {
            console.log(e.code + " " + e.message)
            setVariables(prev => ({
                ...prev,
                loading: false
            }))
            setTimeout(() => {
                showMessage("Error de conexion", "error")
            }, 100)
        })
    }
    const successAlta = async () => {
        await deleteDoc(doc(doc(db, ref), "JugadorBaja", variables.data.correo_jugador)).then(r => {
            setVariables(prev => ({
                ...prev,
                loading: false
            }))
            setTimeout(() => {
                showMessage("Jugador dado de alta correctamente", "success", 2000)
                setTimeout(() => {
                    window.history.back()
                }, 1500)
            }, 100)
        }).catch(e => {
            console.log(e.code + " " + e.message)
            setVariables(prev => ({
                ...prev,
                loading: false
            }))
            setTimeout(() => {
                showMessage("Error de conexion", "error")
            }, 100)
        })
    }
    //Funcion que actualiza el contador de jugadores de la clinica
    const updateClassCont = async (classes) => {
        classes.map(async v => {
            await updateDoc(doc(doc(db, ref), "Clases", v), {
                numero_jugadores: increment(1)
            }).catch(e => {
                console.log(e)
            })
        })
    }
    const updateFinances = async (financesInscripcion, financesMensualidad) => {
        if(financesInscripcion.cantidad > 0){
            await updateDoc(doc(doc(db, ref), "Finanzas", financesInscripcion.fecha), {
                ingresos: arrayUnion({
                    cantidad: financesInscripcion.cantidad,
                    categoria: financesInscripcion.categoria,
                    concepto: financesInscripcion.concepto,
                })
            }).catch(async e => {
                console.log(e.code + " " + e.message)
                //Si nos manda a este error, probablemente es que no exista el documento al que queremos mandar la informacion,
                // entonces debemos de crearlo
                await setDoc(doc(doc(db, ref), "Finanzas", financesInscripcion.fecha), {
                    ingresos: [{
                    cantidad: financesInscripcion.cantidad,
                    categoria: financesInscripcion.categoria,
                    concepto: financesInscripcion.concepto,
                }],
                    egresos: [],
                    fecha: financesInscripcion.fecha
                }).catch(e => {
                    console.log(e)
                    setTimeout(() => {
                        showMessage("Error al registrar nuevas finanzas", "error")
                    })
                })
            })
        }
        if(financesMensualidad.cantidad > 0){
            await updateDoc(doc(doc(db, ref), "Finanzas", financesMensualidad.fecha), {
                ingresos: arrayUnion({
                    cantidad: financesMensualidad.cantidad,
                    categoria: financesMensualidad.categoria,
                    concepto: financesMensualidad.concepto,
                })
            }).catch(async e => {
                console.log(e.code + " " + e.message)
                //Si nos manda a este error, probablemente es que no exista el documento al que queremos mandar la informacion,
                // entonces debemos de crearlo
                await setDoc(doc(doc(db, ref), "Finanzas", financesMensualidad.fecha), {
                    ingresos: [{
                    cantidad: financesMensualidad.cantidad,
                    categoria: financesMensualidad.categoria,
                    concepto: financesMensualidad.concepto,
                }],
                    egresos: [],
                    fecha: financesMensualidad.fecha
                }).catch(e => {
                    console.log(e)
                    setTimeout(() => {
                        showMessage("Error al registrar nuevas finanzas", "error")
                    })
                })
            })
        }
    }

    //Funcion que valida si el jugador ya esta en la clase que se quiere registrar
    const isInClass = (itemValue) => {
        itemValue = JSON.parse(itemValue)
        
        if(itemValue.id != ""){
            
            var count = 0
            for (let i = 0; i < variables.data.clases_jugador.length; i++) {
                if (variables.data.clases_jugador[i] == itemValue.id) {
                    count++
                }
            }

            if (count > 0) {
                setTimeout(() => {
                    showMessage("El jugador ya esta registrado en esa clase", "warning")
                }, 100)
            } else {

                var limite = parseInt(itemValue.limite_jugadores)
                if(limite === 0){
                    variables.clase.push(itemValue.id)
                    setVariables(prev => ({
                        ...prev
                    }))
                } else {
                    if((itemValue.numero_jugadores + 1) <= limite){
                        variables.clase.push(itemValue.id)
                        setVariables(prev => ({
                            ...prev
                        }))
                    } else {
                        showMessage("Ya no hay espacio en la clinica", "warning")
                    }
                }
            }
        }
    }

    //Funcion que quita al jugador de una clase en especifico
    const takeOutPlayer = (index) => {
        variables.clase.splice(index, 1)
        setVariables(prev => ({
            ...prev
        }))
    }

    //Funcion que obtiene los datos del jugador
    const getData = async () => {
        await getDoc(doc(doc(db, ref), "JugadorBaja", id)).then(r => {

            if (r.exists() !== false) {
                getClasses(r.data().clases_jugador, r.data().suscripciones_jugador, r.data())
            } else {
                setTimeout(() => {
                    showMessage("No se encontro al jugador", "error")
                }, 2000)
            }
        }).catch(e => {
            console.log(e.code + " " + e.message)
            setVariables(prev => ({
                ...prev,
                loading: false
            }))
            setTimeout(() => {
                showMessage("Error de conexion", "error")
            }, 100)
        })
    }

    //Funcion que obtiene las clases
    const getClasses = async (cla, sus, dat) => {
        await getDocs(query(collection(doc(db, ref), "Clases"))).then(r => {
            if (r.docs.length > 0) {
                var aux = []

                r.docs.map(v => {
                    if (v.id.split("-").length === 1) {
                        var datos = v.data()

                        var newObject = {
                            id: v.id,
                            descripcion_clase: datos.descripcion_clase,
                            nombre_clase: datos.nombre_clase,
                            nombre_profesor: datos.nombre_profesor,
                            dias_clase: datos.dias_clase,
                            nivel_clase: datos.nivel,
                            id_profesor: datos.profesor_clase,
                            limite_jugadores: datos.limite_jugadores,
                            nivel_clase: datos.nivel,
                            numero_jugadores: datos.numero_jugadores
                        }
                        aux.push(newObject)
                    }
                })

                //Ordenamos cada clase de la lista de las categorias por dias
                for(let i = 0; i < aux.length; i++){
                    //Recibimos una sola clase de la lista+
                    sortByDay(aux[i])
                }

                var aux2 = []
                //Una vez separadas las clases por dias, y teniendo un arreglo de clases por cada dia,
                //Ordenamos la lista que esta en los martes por ejemplo de menor a mayor
                for(let i = 0; i < sortedDaysData.length; i++){

                    //Primero creamos una variable que contendra las horas de clase
                    var h = horas.map((v, i) => [])

                    for(let x = 0; x < sortedDaysData[i].length; x++){

                        //Creamos una variable que almacena las horas de comienzo de cada clase
                        var start = []

                        //Recorremos cada dia de las clases
                        for(let z = 0; z < sortedDaysData[i][x].dias_clase.length; z++){
                            //Las agregamos a la variable de almacenamiento de las horas
                            start.push(parseInt(sortedDaysData[i][x].dias_clase[z].de))
                        }

                        
                        //Ahora validamos recorriendo las horas a cual pertenece cada una
                        for(let z = 0; z < h.length; z++){
                            if(start.includes((z+1))){
                                h[z].push(sortedDaysData[i][x])
                                break
                            }
                        }

                    }

                    h.map((v, i) => {
                        v.map(v2 => {
                            aux2.push(v2)
                        })
                    })

                }

                setVariables(prev => ({
                    ...prev,
                    clase: cla,
                    suscripciones: sus,
                    data: dat,
                    classes: aux2,
                    loading: false
                }))
            }
            setVariables(prev => ({
                ...prev,
                loading: false
            }))
        }).catch(e => {
            console.log(e.code + " " + e.message)
            setVariables(prev => ({
                ...prev,
                loading: false
            }))
            setTimeout(() => {
                showMessage("Error de conexion", "error")
            }, 100)
        })
    }

    useEffect(() => {
        if(!sessionStorage.getItem("homeFlag") || !ref){
            navigate("/home", { replace: true })
        } else {
            getData()
        }
    }, [])

    if (variables.loading)
        return (
            <Loader
                loading={variables.loading}
            />
        )

    if (!variables.loading)
        return (
            <div className='mainPlayerBajaInfo'>

                <Confirm
                    confirm={confirm}
                    setConfirm={setConfirm}
                    onHandle={deletePlayer}
                />

                <Snack />

                <h2 style={{
                    backgroundColor: main,
                    fontFamily: fontType.title,
                    paddingBottom: 0
                }}>{variables.data.nombre_jugador}</h2>
                <h2 style={{
                    backgroundColor: main,
                    fontFamily: fontType.text,
                    marginTop: -50,
                    marginBottom: 40,
                    fontSize: 18,
                    padding: 10,
                    paddingBottom: 20,
                    paddingTop: 0
                }}>{
                    localStorage.getItem("authToken") ? 
                        JSON.parse(localStorage.getItem("authToken")).nombre_academia
                    : ""
                }</h2>

                <Menu
                    academia={academia}
                    reference={ref}
                />

                <div className='playerInfoCont'>

                    <div className='info-one' style={{
                        fontFamily: fontType.text
                    }}>

                        <div className='info-one-item'>
                            <p>Rama</p>
                            <div className='custom-select'>
                                <select id="Rama" name="Rama" style={{
                                    fontFamily: fontType.text
                                }}
                                    disabled={true}
                                    value={variables.data.rama_jugador}
                                    onChange={e => {
                                        const t = e.target.value
                                        setVariables(prev => ({
                                            ...prev,
                                            data: {
                                                ...prev.data,
                                                rama_jugador: t
                                            }
                                        }))
                                    }}
                                >
                                    <option value="Todos">Todos</option>
                                    <option value="Varonil">Varonil</option>
                                    <option value="Femenil">Femenil</option>
                                </select>
                            </div>
                        </div>

                        <div className='info-one-item'>
                            <p>Categoria</p>
                            <div className='custom-select'>
                                <select id="Categoria" name="Categoria" style={{
                                    fontFamily: fontType.text
                                }}
                                    disabled={true}
                                    value={variables.data.categoria_jugador}
                                    onChange={e => {
                                        const t = e.target.value
                                        setVariables(prev => ({
                                            ...prev,
                                            data: {
                                                ...prev.data,
                                                categoria_jugador: t
                                            }
                                        }))
                                    }}
                                >
                                    <option value="Todos">Todos</option>
                                    <option value="">Sin categoria</option>
                                    {
                                        categorias.map(v => {
                                            return (
                                                <option value={v}>{v}</option>
                                            )
                                        })
                                    }
                                </select>
                            </div>
                        </div>

                        <div className='info-one-item'>
                            <p>Nivel</p>
                            <div className='custom-select'>
                                <select id="Nivel" name="Nivel" style={{
                                    fontFamily: fontType.text
                                }}
                                    disabled={true}
                                    value={variables.data.nivel_jugador}
                                    onChange={e => {
                                        const t = e.target.value
                                        setVariables(prev => ({
                                            ...prev,
                                            data: {
                                                ...prev.data,
                                                nivel_jugador: t
                                            }
                                        }))
                                    }}
                                >
                                    <option value="Todos">Todos</option>
                                    <option value="">Sin nivel</option>
                                    {
                                        niveles.map(v => {
                                            return (
                                                <option value={v}>{v}</option>
                                            )
                                        })
                                    }
                                </select>
                            </div>
                        </div>

                        <div className='info-one-item'>
                            <p>Edad: <span style={{ fontWeight: "lighter" }}>{variables.data.edad_jugador ? getAge(variables.data.edad_jugador) : "Loading..."}</span></p>
                        </div>

                        <div className='info-one-item'>
                            <p>Correo</p>
                            <input
                                style={{
                                    color: "#AAA"
                                }}
                                disabled={true}
                                placeholder={validateEmail(variables.data.correo_jugador) ? variables.data.correo_jugador : "No hay un correo registrado"}
                                maxLength={50}
                                onChange={e => {
                                    const t = e.target.value

                                    setVariables(prev => ({
                                        ...prev,
                                        data: {
                                            ...prev.data,
                                            correo_jugador: t
                                        }
                                    }))
                                }}
                            />
                        </div>

                        <div className='info-one-item'>
                            <p>Telefono</p>
                            <input
                                disabled={true}
                                style={{
                                    color: "#AAA"
                                }}
                                placeholder={variables.data.telefono_jugador}
                                maxLength={10}
                                onChange={e => {
                                    const t = e.target.value

                                    setVariables(prev => ({
                                        ...prev,
                                        data: {
                                            ...prev.data,
                                            telefono_jugador: t
                                        }
                                    }))
                                }}
                            />
                        </div>

                        <div className='info-one-item'>
                            <p>Fecha de registro</p>
                            <p style={{
                                fontWeight: "lighter",
                                textAlign: "center",
                                marginBottom: 20
                            }}>{variables.data.fecha_inscripcion ? variables.data.fecha_inscripcion : "No hay una fecha registrada"}</p>
                        </div>

                        <div className='info-one-item'>
                            <p>Ultima baja</p>
                            <p style={{
                                fontWeight: "lighter",
                                textAlign: "center",
                                marginBottom: 20
                            }}>{variables.data.fecha_baja ? variables.data.fecha_baja : "No ha sido dado de baja el jugador"}</p>
                        </div>

                        <div className='info-one-item'>
                            <p>Ranking</p>
                            <div className='ranking'>
                                <p>{variables.data.ranking_jugador}</p>
                            </div>
                        </div>

                    </div>

                    <div className='info-two' style={{
                        fontFamily: fontType.text
                    }}>

                        <div className='contClasses'>
                            <p style={{
                                fontWeight: "bold",
                                fontSize: 18
                            }}>Clases</p>
                            <div className='classes'>
                                {
                                    variables.clase.length > 0 ?
                                        variables.clase.map((v, i) => {
                                            let clase = variables.classes.find(c => c.id == v)
                                            return (
                                                <div className='clase'>
                                                    <div className='item' style={{
                                                        cursor: "pointer"
                                                    }}>
                                                        <p style={{
                                                            fontWeight: "bold",
                                                            marginBottom: 20
                                                        }}>{clase.nombre_profesor}</p>
                                                        <p>{clase.nombre_clase}</p>
                                                        <p>{clase.descripcion_clase}</p>
                                                    </div>
                                                    <div className='item' style={{
                                                        cursor: "pointer"
                                                    }}
                                                        onClick={() => {
                                                            takeOutPlayer(i)
                                                        }}
                                                    >
                                                        <MdDeleteOutline size={30} color='black' />
                                                    </div>
                                                </div>
                                            )
                                        })
                                    :
                                        <p style={{
                                            marginTop: 50,
                                            marginBottom: 50,
                                            textAlign: "center"
                                        }}>No hay clases para este jugador.</p>
                                }

                                <div className='custom-select'>
                                    <select id="Clases" name="Clases" style={{
                                        fontFamily: fontType.text,
                                        width: "100%"
                                    }}
                                    value={""}
                                        onChange={e => {
                                            const t = e.target.value

                                            isInClass(t)
                                        }}
                                    >
                                        <option value={""}>...</option>
                                        {
                                            variables.classes.map((v, i) => {
                                                return (
                                                    <option style={{
                                                        borderBottomWidth: 1
                                                    }} value={JSON.stringify({id: v.id, limite_jugadores: v.limite_jugadores, numero_jugadores: v.numero_jugadores})}>{(v.dias_clase ? formatSubtitle(v.dias_clase) : "") + " " + v.nombre_profesor}</option>
                                                )
                                            })
                                        }
                                    </select>
                                </div>
                            </div>
                        </div>

                        <div className='contSuscripciones'>
                            <p style={{
                                fontWeight: "bold",
                                fontSize: 18
                            }}>Suscripciones</p>
                            <div className='suscripciones'>
                                {
                                    variables.suscripciones.length > 0 ?
                                        variables.suscripciones.map((v, i) => {
                                            return (
                                                <div className='suscripcion'>
                                                    <div className='contInfo'>
                                                        <p>{v.suscripcion}</p>
                                                        <div className='contPagos'>
                                                            <div className='pago'>
                                                                <p>Por pagar</p>
                                                                <input
                                                                    type='number'
                                                                    defaultValue={variables.suscripciones[i].por_pagar}
                                                                    onChange={e => {
                                                                        const t = e.target.value

                                                                        if(t === ""){
                                                                            variables.suscripciones[i].por_pagar = 0
                                                                        } else {
                                                                            variables.suscripciones[i].por_pagar = t
                                                                        }
                                                                    }}
                                                                />
                                                            </div>
                                                            <div className='pago'>
                                                                <p>Pagado</p>
                                                                <input
                                                                    type='number'
                                                                    defaultValue={variables.suscripciones[i].pagado}
                                                                    onChange={e => {
                                                                        const t = e.target.value

                                                                        if(t === ""){
                                                                            variables.suscripciones[i].pagado = 0
                                                                        } else {
                                                                            variables.suscripciones[i].pagado = t
                                                                        }
                                                                    }}
                                                                />
                                                            </div>
                                                        </div>

                                                        <input
                                                            className='input-fecha'
                                                            style={{
                                                                fontFamily: fontType.text,
                                                                padding: 5,
                                                                marginTop: 10,
                                                                borderRadius: 5,
                                                                borderWidth: 2,
                                                                borderColor: "#DDD",
                                                                borderStyle: "solid"
                                                            }}
                                                            placeholder='Comentarios'
                                                            value={variables.suscripciones[i].comentarios}
                                                            onChange={e => {
                                                                variables.suscripciones[i].comentarios = e.target.value
                                                                setVariables(prev => ({
                                                                    ...prev
                                                                }))
                                                            }}
                                                        />
                                                        
                                                        <input
                                                            className='input-fecha'
                                                            style={{
                                                                fontFamily: fontType.text,
                                                                padding: 5,
                                                                marginTop: 10,
                                                                borderRadius: 5,
                                                                borderWidth: 2,
                                                                borderColor: "#DDD",
                                                                borderStyle: "solid"
                                                            }}
                                                            type='date'
                                                            onChange={e => {
                                                                variables.suscripciones[i].fecha_pago = e.target.value
                                                                setVariables(prev => ({
                                                                    ...prev
                                                                }))
                                                            }}
                                                        />
                                                        <p style={{
                                                            width: "100%",
                                                            textAlign: "center"
                                                        }}>{v.fecha_pago}</p>

                                                    </div>
                                                </div>
                                            )
                                        })
                                    :
                                        <p style={{
                                            marginTop: 50,
                                            marginBottom: 50,
                                            textAlign: "center"
                                        }}>No hay suscripciones para este jugador.</p>
                                }
                            </div>
                        </div>

                        <div className='contButtons'>
                            <div class='buttons'>
                                <button onClick={() => {
                                    altaPlayer()
                                }} style={{
                                    fontFamily: fontType.subTitle,
                                    backgroundColor: main
                                }}>Dar de alta</button>
                                <button onClick={() => {
                                    setConfirm(prev => ({
                                        ...prev,
                                        text: "¿Estas seguro de eliminar a este jugador permanentemente?",
                                        title: "Eliminar jugador",
                                        show: true
                                    }))
                                }} style={{
                                    fontFamily: fontType.subTitle,
                                    backgroundColor: "#A00"
                                }}>Eliminar</button>
                            </div>
                        </div>

                    </div>

                </div>

            </div>
        )
}

export default PlayerInfoBaja